import {Pipe, PipeTransform} from '@angular/core';
import * as $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'html'})

export class HtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(input: string ): any {
        if (input == null) {
            return'';
        }

        return this.sanitizer.bypassSecurityTrustHtml(input);
    }
}
